export interface ShiftCloseCashInputs {
  cashOpen: number;
  loyverseCashTotal: number | null;
  otherSalesCashTotal: number;
  purchasesTotal: number;
  otherExpensesTotal: number;
  depositApplies: boolean;
  depositAmount: number | null;
}

/**
 * Fase 19A: espejo en frontend de la fórmula que calcula `shiftCloseService.createShiftClose` en el
 * backend — usado solo para la vista previa en vivo antes de guardar (igual que
 * `calculateExpenseTaxBreakdown`/`calculateOtherSaleTaxBreakdown`). El backend recalcula esto de
 * forma autoritativa con los datos frescos al momento de guardar, así que esta copia nunca es la
 * fuente de verdad. Replica exactamente la fórmula real de Apps Script
 * (`ShiftCloseService.saveShiftClose_`) — ver docs/SHIFT_CLOSE_APPS_SCRIPT_PARITY.md sección 5:
 *
 *   expectedCash = cashOpen + loyverseCashTotal + otherSalesCashTotal
 *                  - purchasesTotal - otherExpensesTotal - depositAmount
 *
 * `loyverseCashTotal === null` (sin desglose confiable de métodos de pago) se trata como 0, igual
 * que el backend — el resto de la fórmula sigue siendo útil aunque esa porción no sea confiable.
 */
export function calculateExpectedCash(inputs: ShiftCloseCashInputs): number {
  const loyverseCashTotal = inputs.loyverseCashTotal ?? 0;
  const depositAmount = inputs.depositApplies ? (inputs.depositAmount ?? 0) : 0;
  return round2(inputs.cashOpen + loyverseCashTotal + inputs.otherSalesCashTotal - inputs.purchasesTotal - inputs.otherExpensesTotal - depositAmount);
}

function round2(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

/**
 * P-075 · Cómo se llama en el corte el efectivo de lo vendido en Negocio360 (punto de venta y capturas
 * manuales). Con Loyverse hay que distinguirlo de «Ventas Loyverse en efectivo»; sin Loyverse es,
 * simplemente, lo vendido en efectivo. La misma regla en la pantalla del corte, su historial y su detalle
 * (antes el historial decía siempre «Ventas Otros»). `showLoyverseData` = presencia de Loyverse ≠ false.
 */
export function nativeCashLabel(showLoyverseData: boolean): string {
  return showLoyverseData ? 'Ventas e ingresos (efectivo)' : 'Ventas en efectivo';
}
